module.exports = "/assets/data/3839a8d01fa5059cea24237ffbcb067d-WF16.data.json";